import { render, staticRenderFns } from "./CorporateKnowledge.vue?vue&type=template&id=4640fbd6&scoped=true&"
import script from "./CorporateKnowledge.vue?vue&type=script&lang=js&"
export * from "./CorporateKnowledge.vue?vue&type=script&lang=js&"
import style0 from "./CorporateKnowledge.vue?vue&type=style&index=0&id=4640fbd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4640fbd6",
  null
  
)

export default component.exports